module.exports = __webpack_public_path__ + "img/5.8d4895d6.jpg";